import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikValues } from 'formik';

import {
  IUseSetGroupEditTable,
  SetGroupEditTableMode,
} from '../../../components/reusable/set-group-edit-table/interfaces';
import { useExerciseResultsForSetAutofill } from '../../../hooks/use-exercise-results-for-set-autofill';
import { ExerciseOptionType } from '../../../shared/constants';
import { IProgramSet } from '../../../types/interfaces/program-set';

function useEditTable(
  formik: FormikValues,
): IUseSetGroupEditTable<IProgramSet> {
  const { t } = useTranslation();
  const exerciseResults = useExerciseResultsForSetAutofill(undefined);
  const onChangeSet = useCallback(
    (set: IProgramSet) => {
      formik.setValues((prev) => ({ ...prev, ...set }));
    },
    [formik],
  );

  return {
    options: {
      hideSuperset: true,
      hideSetsCount: false,
      hideExpand: true,
      hideHeader: true,
      hideSavedSetUploading: true,
      removeSetMode: 'none',
      hideSaveSet: true,
    },
    exerciseResults,
    mode: SetGroupEditTableMode.program,
    maxSetNumber: 0,
    submitCalled: formik.submitCount > 0,
    optionValidators: [
      {
        message: t('formikValidation.minValue').replace('{0}', '0'),
        validator: (value: number) => {
          return value < 0;
        },
      },
      {
        type: ExerciseOptionType.integer,
        message: t('formikValidation.integerValueRequired'),
        validator: (value: number) => {
          return +value === value ? !Number.isInteger(value) : true;
        },
      },
    ],
    onChangeSet,
  };
}

export default useEditTable;
